import React, { useState } from 'react'

interface CollapsibleNoteProps {
    text: string
    maxLength?: number
}

const CollapsibleNote: React.FC<CollapsibleNoteProps> = ({ text, maxLength = 500 }) => {
    const [expanded, setExpanded] = useState(false)

    if (!text) return null

    const isLong = text.length > maxLength
    const displayText = expanded ? text : text.substring(0, maxLength) + (isLong ? '...' : '')

    return (
        <div
            style={{
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                lineHeight: '1.6',
                marginBottom: '0.75rem',
            }}
        >
            {displayText}
            {isLong && (
                <button
                    type="button"
                    className="btn btn-link p-0 ms-3 align-baseline"
                    onClick={() => setExpanded(!expanded)}
                    style={{
                        fontSize: '0.9rem',
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        color: '#0d6efd',
                        textDecoration: 'none',
                        transition: 'text-decoration 0.2s ease',
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.textDecoration = 'underline'
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.textDecoration = 'none'
                    }}
                >
                    {expanded ? 'Show less' : 'Show more'}
                </button>
            )}
        </div>
    )
}

export default CollapsibleNote
